module.exports = __webpack_public_path__ + "static/media/text_1.72e93721.svg";